(() => {
  const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
  const sine = (t) => -(Math.cos(Math.PI * t) - 1) / 2;
  const init = (root) => {
    const hero = root.querySelector('[data-leo-hero]');
    if (!hero || hero.dataset.ready) return;
    hero.dataset.ready = '1';
    const laps = [...hero.querySelectorAll('[data-leo-lap]')];
    const lids = laps.map((l) => l.querySelector('[data-leo-lid]'));
    const nows = [...hero.querySelectorAll('[data-leo-now-item]')];
    const ticks = [...hero.querySelectorAll('[data-leo-tick]')];
    const n = laps.length;
    if (!n) return;
    const startOpen = parseFloat(hero.dataset.startOpen || '0.25');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const mq = window.matchMedia('(min-width: 0px)');
    const INTRO = 0.8; const HOLD = 0.32; const OUTRO = 0.4;
    let active = -1; let timer = null; let target = 0; let shown = 0; let raf = 0;
    const setActive = (i) => {
      if (i === active) return;
      active = i;
      nows.forEach((el, k) => el.classList.toggle('is-on', k === i));
      ticks.forEach((el, k) => el.classList.toggle('is-on', k === i));
    };
    const paint = (c, intro) => {
      const lw = laps[0].offsetWidth;
      const side = clamp((intro - 0.55) / 0.45);
      laps.forEach((lap, k) => {
        const d = k - c; const ad = Math.abs(d);
        const s = 1 - Math.min(ad, 1.4) * 0.4;
        const x = d * lw * (0.62 + 0.18 * side) + (d === 0 ? 0 : Math.sign(d) * (1 - side) * lw * 0.25);
        const y = Math.min(ad, 1) * lw * 0.03;
        lap.style.transform = `translate3d(${x.toFixed(1)}px, ${y.toFixed(1)}px, 0) scale(${s.toFixed(3)})`;
        lap.style.zIndex = String(100 - Math.round(ad * 10));
        lap.style.visibility = ad > 1.7 ? 'hidden' : 'visible';
        lap.style.opacity = ad < 0.5 ? '1' : side.toFixed(3);
        lap.style.setProperty('--dimv', (Math.min(ad, 1) * 0.55).toFixed(3));
        const open = ad < 0.5 ? startOpen + (1 - startOpen) * ease(clamp(intro / 0.85)) : 1;
        lids[k].style.transform = `rotateX(${(-82 + 82 * open).toFixed(2)}deg)`;
      });
      hero.style.setProperty('--open', intro.toFixed(3));
    };
    const render = (p) => {
      const total = INTRO + (n - 1) + OUTRO;
      const u = p * total;
      if (u < INTRO) { setActive(0); paint(0, ease(clamp(u / INTRO))); hero.classList.remove('is-moving'); return; }
      const s = u - INTRO;
      if (s >= n - 1) { setActive(n - 1); paint(n - 1, 1); hero.classList.remove('is-moving'); return; }
      const seg = Math.floor(s); const t = s - seg;
      const k = t < HOLD ? 0 : sine((t - HOLD) / (1 - HOLD));
      hero.classList.toggle('is-moving', t >= HOLD);
      const c = seg + k;
      setActive(Math.round(c));
      paint(c, 1);
    };
    const tick = () => {
      shown += (target - shown) * 0.085;
      if (Math.abs(target - shown) < 0.0002) shown = target;
      render(shown);
      raf = shown !== target ? requestAnimationFrame(tick) : 0;
    };
    const onScroll = () => {
      const r = hero.getBoundingClientRect();
      const total = hero.offsetHeight - window.innerHeight;
      target = clamp(-r.top / Math.max(total, 1));
      hero.style.setProperty('--lift', window.scrollY > 300 && r.bottom > window.innerHeight ? '1' : '0');
      if (!raf) raf = requestAnimationFrame(tick);
    };
    const mobileGo = (i) => { setActive(i); laps.forEach((lap, k) => lap.style.setProperty('--m', k - i)); };
    const auto = () => { clearInterval(timer); timer = setInterval(() => mobileGo((active + 1) % n), 3400); };
    const mode = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      clearInterval(timer);
      laps.forEach((l) => { l.style.transform = ''; l.style.visibility = ''; l.style.zIndex = ''; l.style.opacity = ''; l.style.removeProperty('--dimv'); });
      lids.forEach((l) => { l.style.transform = ''; });
      if (mq.matches && !reduce) {
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        onScroll(); shown = target; render(shown);
      } else {
        hero.style.setProperty('--open', '1');
        mobileGo(Math.max(active, 0));
        if (!reduce) auto();
      }
    };
    ticks.forEach((t, k) => t.addEventListener('click', () => {
      if (mq.matches && !reduce) {
        const total = hero.offsetHeight - window.innerHeight;
        const top = hero.getBoundingClientRect().top + window.scrollY;
        const units = INTRO + (n - 1) + OUTRO;
        const u = k === 0 ? INTRO : INTRO + k;
        window.scrollTo({ top: top + total * (u / units), behavior: 'smooth' });
      } else { mobileGo(k); auto(); }
    }));
    let sx = null;
    hero.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', (e) => {
      if (sx === null || mq.matches) return;
      const dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) { mobileGo((active + (dx < 0 ? 1 : -1) + n) % n); auto(); }
    });
    mq.addEventListener('change', mode);
    mode();
  };
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();